import { AudioPinComponentRenderer } from '@lessonup/pin-renderer';
import { AudioPinComponent } from '@lessonup/pins-shared';
import { usePlayerDispatcher } from '@lessonup/players-modern';
import { colorSets, styled } from '@lessonup/ui-components';
import React, { useCallback } from 'react';
import { useSelectable } from '../../../../hooks/useSelectable';

interface AudioPinComponentRealtimePlayerProps {
  pinId: string;
  pinComponent: AudioPinComponent;
  active: boolean;
}

export const AudioPinComponentRealtimePlayer: React.FC<AudioPinComponentRealtimePlayerProps> = ({
  pinId,
  pinComponent,
  active,
}) => {
  const playerDispatcher = usePlayerDispatcher();
  const { isSelected, isSelectedByOthers, handleSelect, ref } = useSelectable('pinComponent', pinComponent.id);

  const getShadowColor = () => {
    if (isSelected) return colorSets.active.on;
    if (isSelectedByOthers) return colorSets.active.on;
    return undefined;
  };

  const bodyShown = pinComponent.settings.showBody;
  const handleShowBody = useCallback(() => {
    playerDispatcher({
      type: 'updatePinComponentSettings',
      pinComponentId: pinComponent.id,
      settings: { showBody: !bodyShown },
    });
  }, [playerDispatcher, pinComponent, bodyShown]);

  return (
    <StyledAudioWrapper
      ref={ref}
      onClick={handleSelect}
      style={{
        boxShadow: getShadowColor() ? `0 0 0 2px ${getShadowColor()}` : undefined,
      }}
    >
      <AudioPinComponentRenderer
        pinId={pinId}
        pinComponent={pinComponent}
        active={active}
        onClickContent={handleShowBody}
      />
    </StyledAudioWrapper>
  );
};
/* Account for audio component's internal offset, TODO: is this correct? */
const StyledAudioWrapper = styled.div`
  border-radius: 100%;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  :hover {
    box-shadow: 0 0 0 2px ${colorSets.active.stroke};
  }
`;
